var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcapitalDecoration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1921,
    height: 444,
    viewBox: "0 0 1921 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1990_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315 265.847C315 283.992 328.05 298.694 328.05 298.694C328.05 298.694 341.099 283.992 341.099 265.847C341.099 247.701 328.05 233 328.05 233C328.05 233 315 247.701 315 265.847Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.882 261.84H327.195V316.979H328.882V261.84Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 275.46C287 288.419 296.32 298.919 296.32 298.919C296.32 298.919 305.641 288.419 305.641 275.46C305.641 262.5 296.32 252 296.32 252C296.32 252 287 262.5 287 275.46Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.916 272.598H295.711V311.979H296.916V272.598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.758 235.46C897.758 248.419 907.078 258.919 907.078 258.919C907.078 258.919 916.398 248.419 916.398 235.46C916.398 222.5 907.078 212 907.078 212C907.078 212 897.758 222.5 897.758 235.46Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.674 232.598H906.469V271.979H907.674V232.598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.242 282.331C255.242 293.562 263.319 302.661 263.319 302.661C263.319 302.661 271.397 293.562 271.397 282.331C271.397 271.099 263.319 262 263.319 262C263.319 262 255.242 271.099 255.242 282.331Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.837 279.85H262.793V313.978H263.837V279.85Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M866 248.331C866 259.562 874.077 268.661 874.077 268.661C874.077 268.661 882.154 259.562 882.154 248.331C882.154 237.099 874.077 228 874.077 228C874.077 228 866 237.099 866 248.331Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.595 245.85H873.551V279.978H874.595V245.85Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628 404H823.109H1457V272.027H823.119V272C797.84 272 777.398 284.69 775.419 300.811C767.11 298.422 757.931 297.068 748.275 297.068C710.936 297.068 680.662 316.893 680.662 341.344C680.662 342.592 680.797 343.813 680.942 345.034C679.284 344.921 677.596 344.828 675.876 344.828C649.446 344.828 628 386.803 628 404Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.705 327.206C48.3884 293.489 -46.9999 313.136 -46.9999 313.136V440.556H2175C2175 440.556 1760.14 318.89 1442.99 318.89C991.839 318.89 1038.19 377.433 471.135 327.241L470.705 327.206Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.97 260.999C1547.95 261.634 1547.92 262.309 1547.9 263.046C1547.99 261.439 1547.98 260.692 1547.97 260.999Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1295.34 303.275C1294.95 301.822 1294.62 300.154 1294.33 298.322C1296.46 314.133 1300.67 328.766 1308.78 345.744C1308.78 345.744 1315.63 362.588 1333.63 380.936C1343.91 391.446 1357.85 402.436 1376.22 411.053C1379.96 412.813 1383.87 414.46 1387.98 415.995C1393.86 418.196 1404.55 419.72 1419.18 419.229C1420.67 419.178 1422.2 419.106 1423.77 419.014C1424.84 418.953 1425.91 418.881 1427.01 418.799C1427.61 418.697 1428.2 418.584 1428.78 418.472C1430.85 418.073 1432.89 417.633 1434.9 417.142C1435.76 416.937 1436.58 416.732 1437.35 416.538C1438.14 416.333 1438.89 416.139 1439.6 415.944C1442.6 415.115 1445.52 414.205 1448.36 413.202C1446.01 413.887 1436.77 416.333 1423.77 416.968C1422.29 417.039 1420.75 417.09 1419.18 417.111C1406.83 417.275 1391.77 415.658 1376.22 409.702C1361.86 404.227 1347.07 395.038 1333.63 380.148C1318.22 363.058 1304.56 338.447 1295.34 303.275V303.275Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.21 85V255.201C1292.21 265.444 1292.36 274.634 1292.88 283.24C1292.05 267.389 1292.61 250.227 1292.61 250.227V85.2763C1292.54 85.2251 1292.49 85.1842 1292.43 85.1535C1292.3 85.0512 1292.22 85 1292.21 85Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423.18 284.871V380.778C1424.69 381.136 1426.22 381.433 1427.77 381.688C1433.17 382.589 1438.77 382.947 1444.06 383.009C1448.53 383.06 1452.98 382.783 1457.38 382.19V282.057L1427.77 284.492L1423.18 284.871V284.871Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.52 275.549C1349.29 311.692 1357.95 339.722 1376.3 359.78V198.84L1346.92 208.582C1346.92 208.582 1346.7 233.232 1346.92 249.024C1347.06 259.384 1346.92 263.415 1347.52 275.549Z",
    fill: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1990_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1457.38 282.039V382.183C1466.32 380.975 1475.04 378.447 1483.28 374.641V301.001L1457.38 282.039V282.039Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_1990_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1376.3 198.824V359.774C1385.36 369.68 1397.1 377.56 1412.34 383.29C1414.54 384.119 1416.86 384.795 1419.26 385.347C1420.77 385.705 1422.29 386.002 1423.84 386.258V233.955L1376.3 198.824Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1990_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1292.88 283.245C1292.9 283.399 1292.87 288.644 1292.88 288.797C1293.2 293.76 1293.67 293.438 1294.31 298.094C1294.31 298.165 1294.32 298.247 1294.34 298.319C1294.62 300.151 1294.96 301.819 1295.34 303.272C1304.56 338.444 1318.22 363.055 1333.64 380.145C1347.08 395.034 1361.87 404.224 1376.22 409.699C1391.78 415.654 1406.84 417.271 1419.19 417.107C1420.76 417.087 1422.3 417.036 1423.77 416.964C1436.77 416.33 1446.01 413.884 1448.37 413.198C1448.38 413.198 1448.4 413.188 1448.41 413.188C1450.09 412.605 1451.75 411.991 1453.38 411.346C1462.84 407.642 1471.48 403.078 1479.28 397.992C1501.17 383.747 1516.52 368.606 1525.26 353.88C1537.59 335.582 1545.8 345.987 1548.04 349.026C1546.55 349.026 1541.59 326.133 1504.08 361.858C1496.63 368.96 1488.24 374.619 1479.28 378.753C1471.05 382.56 1462.32 385.087 1453.38 386.295C1448.98 386.888 1444.54 387.165 1440.07 387.114C1434.77 387.052 1429.17 386.694 1423.77 385.793C1422.22 385.538 1420.69 385.241 1419.19 384.883C1416.79 384.33 1414.47 383.655 1412.27 382.826C1397.03 377.095 1385.29 369.215 1376.22 359.31C1357.88 339.252 1350.97 316.137 1347.44 275.079C1347.07 270.689 1346.85 248.554 1346.85 248.554V124.813C1346.85 124.813 1297.54 88.7811 1292.61 85.2812V250.232C1292.61 250.232 1292.05 267.394 1292.88 283.245Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1250 123.222V277.898C1250 279.556 1250.03 281.265 1250.09 283.005C1252.21 343.545 1290.93 386.075 1333.63 406.849C1346.56 413.132 1359.84 417.42 1372.58 419.62C1373.8 419.835 1375.02 420.019 1376.22 420.193C1392.13 422.495 1407.05 421.759 1419.18 420.07C1420.76 419.855 1422.29 419.62 1423.77 419.374C1425.52 419.088 1427.19 418.781 1428.78 418.464C1430.98 418.023 1433.02 417.573 1434.9 417.133C1435.76 416.928 1436.58 416.724 1437.35 416.529C1438.14 416.325 1438.89 416.13 1439.6 415.936C1445.06 414.462 1448.38 413.234 1448.89 413.04C1448.8 413.06 1448.65 413.111 1448.41 413.183C1448.39 413.183 1448.37 413.193 1448.36 413.193C1446.01 413.879 1436.77 416.325 1423.77 416.959C1422.29 417.031 1420.75 417.082 1419.18 417.102C1406.83 417.266 1391.77 415.649 1376.22 409.694C1361.86 404.219 1347.07 395.029 1333.63 380.14C1318.22 363.05 1304.27 339.564 1295.34 303.267C1294.95 301.814 1294.62 300.146 1294.33 298.314C1294.31 298.242 1294.3 298.16 1294.3 298.089C1293.63 293.883 1293.19 288.879 1292.91 283.701C1292.91 283.547 1292.88 283.24 1292.88 283.24L1292.61 250.227V85C1292.61 85 1292.54 85.0512 1292.43 85.1535C1292.38 85.2047 1292.3 85.2661 1292.21 85.3479C1287.9 89.1547 1250 123.099 1250 123.222Z",
    fill: "#EBEFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1990_3186",
    x: 1457.38,
    y: 282.039,
    width: 30.9043,
    height: 106.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1990_3186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1990_3186",
    result: "effect2_innerShadow_1990_3186"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1990_3186",
    x: 1376.3,
    y: 198.824,
    width: 52.5469,
    height: 193.434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1990_3186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1990_3186",
    result: "effect2_innerShadow_1990_3186"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1990_3186",
    x: 1292.42,
    y: 85.2812,
    width: 260.619,
    height: 337.838,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1990_3186"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1990_3186",
    result: "effect2_innerShadow_1990_3186"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1990_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1921,
    height: 444,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcapitalDecoration);
export default __webpack_public_path__ + "static/media/vcapital-decoration.60d2babbd096feed3e43dab3edf97ae7.svg";
export { ForwardRef as ReactComponent };